export default __webpack_public_path__ + "static/media/zomatel.12521f5f.jpg";